<template>
  <!--半成品配方-->
  <a-modal :title="record.name" :visible="!loading" @cancel="cancel">
    <a-row
      type="flex"
      align="bottom"
      :gutter="20"
      class="m-b-20"
      v-for="(f, index) in formula"
      :key="index"
    >
      <a-col :span="10">
        <div class="m-b-12" v-if="index === 0">选择原材料</div>
        <a-select show-search v-model="f.rawMaterial.name" style="width: 100%">
          <a-select-option
            v-for="m in materials"
            :key="m.id"
            :value="m.name"
            @click="select(m, index)"
          >{{m.name}}</a-select-option>
        </a-select>
      </a-col>
      <a-col :span="10">
        <div class="m-b-12" v-if="index === 0">重量(KG)</div>
        <a-input-number
          :min="0"
          v-model="f.weight"
          style="width: 100%"
          @blur="focus(f.weight, index)"
        ></a-input-number>
      </a-col>
      <!--<a-col :span="10">-->
      <!--<ak-type-input v-model="item.rawMaterial" :field="field1"/>-->
      <!--</a-col>-->
      <!--<a-col :span="10">-->
      <!--<ak-type-input v-model="item.weight" :field="field2"/>-->
      <!--</a-col>-->
      <a-col :span="4" class="text-center p-b-4">
        <tk-icon @click.native="deleteMaterial(index)">delete</tk-icon>
      </a-col>
    </a-row>
    <a-divider v-if="formula.length" />
    <a-row type="flex" justify="center">
      <a-col>
        <a-button v-if="!loading" size="large" style="font-size: 14px" @click="addMaterial">
          <tk-icon size="16" class="m-x-5 p-b-4">plus</tk-icon>增加原材料
        </a-button>
      </a-col>
    </a-row>
    <template slot="footer">
      <tk-flex between middle>
        <div class="font-18 font-bold">材料费：{{total || ''}}</div>
        <tk-flex>
          <a-button @click="cancel">取消</a-button>
          <a-button :loading="loading" type="primary" @click="submit">确定</a-button>
        </tk-flex>
      </tk-flex>
    </template>
  </a-modal>
</template>

<script>
import NP from 'number-precision'
import store from '@/store'
export default {
  data () {
    return {
      loading: true,
      field1: {
        name: 'rawMaterial',
        note: '选择原材料',
        type: 'Pointer',
        targetClass: 'rawMaterial'
        // validators: [
        //   (val) => val ? null : '选项不可为空'
        // ]
      },
      field2: {
        name: 'weight',
        note: '重量(KG)',
        type: 'Number'
        // validators: [
        //   (val) => val ? null : '重量不可为空',
        //   (val) => {
        //     if (val <= 0) {
        //       return '请输入正确的重量'
        //     }
        //   }
        // ]
      },
      formula: [], // 配方
      materials: [], // 原材料
      // 配方初始值
      oriData: {
        formula: [],
        rawMaterialId: []
      },
      oriPriceGroup: [],
      finalPriceGroup: [],
      priceLog: []
    }
  },
  computed: {
    total () {
      let total = 0
      this.formula.forEach((e) => {
        if (e.price) {
          total = NP.plus(total, e.price)
        }
      })
      return NP.round(total, 2)
    }
  },
  created () {
    this.unWatch = this.$watch(() => this.oriPriceGroup, this.listenConfirm)
  },
  async mounted () {
    this.$loading.show('查询数据中，请稍后')
    this.getMaterial()
    await this.getOriData()
    // console.log('original', this.oriPriceGroup)
    if (this.record.formula && this.record.formula.length) {
      // this.formula = this.record.formula
      this.formula = await this.$tkHelper.deepClone(this.record.formula)
    }
  },
  methods: {
    // 判断确认是否可点击
    listenConfirm () {
      if (this.oriPriceGroup) {
        this.loading = false
      }
    },
    // 获取配方初始值
    async getOriData () {
      if (this.record.formula) { this.oriData.formula = this.record.formula }
      if (this.record.rawMaterialId) { this.oriData.rawMaterialId = this.record.rawMaterialId }
      let { data: q } = await this.$tkParse.post('/totalPrice/reasonParts', this.record.objectId)
      this.oriPriceGroup = q
      this.$loading.hide()
    },
    cancel () {
      this.$emit('complete', 'cancel')
    },
    // 获取原材料
    async getMaterial () {
      let res = await this.$modelAjax.getData('rawMaterial', {
        params: { limit: 10000 }
      }).catch(e => {
        this.$notification['error']({
          message: '网络错误，请重新尝试',
          description: '获取原材料失败'
        })
      })
      this.materials = res.results
    },
    // 添加配方
    addMaterial () {
      this.formula.push({ rawMaterial: {}, weight: null, price: 0 })
    },
    // 删除配方
    deleteMaterial (index) {
      this.formula.splice(index, 1)
    },
    // 选择原材料
    select (m, index) {
      this.formula[index].rawMaterial = m
      // 判断此项是否有重量,有重量计算此项费用
      if (this.formula[index].weight) {
        this.formula[index].price = NP.times(m.price, m.rate, this.formula[index].weight, 0.001, 0.01)
      }
    },
    // 失去焦点
    focus (weight, index) {
      // 判断此项是否有原材料，已选择原材料计算此项费用
      if (weight && this.formula[index].rawMaterial.name) {
        this.formula[index].price = NP.times(this.formula[index].rawMaterial.price, this.formula[index].rawMaterial.rate, weight, 0.001, 0.01)
      }
      if (!weight) { this.formula[index].price = 0 }
    },
    // 判断半成品配方是否改变
    judgeFormula () {
      if (this.oriData.formula.length === 0 && this.oriData.formula.rawMaterialId.length === 0) { return true } else {
        let judgeFormula = []
        // 判断配方
        let f = this.formula
        if (this.oriData.formula.sort().length === f.sort().length) {
          for (let i in f) {
            if (f.sort()[i].rawMaterial === this.oriData.formula.sort()[i].rawMaterial && f.sort()[i].price === this.oriData.formula.sort()[i].price) { judgeFormula.push(true) } else {
              judgeFormula.push(false)
              // return
            }
          }
        } else {
          judgeFormula.push(false)
          // return
        }
        return judgeFormula.every(e => e === true)
      }
    },
    // 记录价格日志
    async toPriceLog () {
      if (this.judgeFormula) {
        let { data: q } = await this.$tkParse.post('/totalPrice/reasonParts', this.record.objectId)
        this.finalPriceGroup = q
        console.log('final', this.finalPriceGroup)
        for (let x in this.oriPriceGroup) {
          for (let y in this.finalPriceGroup) {
            if ((this.oriPriceGroup[x].objectId === this.finalPriceGroup[y].objectId) && (this.oriPriceGroup[x].price !== this.finalPriceGroup[y].price)) {
              // 提交价格日志
              let log = {
                name: '',
                type: '',
                oriPrice: '',
                price: '',
                user: store.state.user.name,
                reason: 'partsChanged',
                describe: ''
              }
              log.oriPrice = this.oriPriceGroup[x].price
              log.price = this.finalPriceGroup[y].price
              log.name = this.oriPriceGroup[x].name
              log.price = this.finalPriceGroup[y].price
              log.describe = '由' + log.oriPrice + '变为' + log.price
              if (this.finalPriceGroup[y].isBatching) {
                log.type = 'batchingFinishProduct'
              } else {
                log.type = 'finishProduct'
              }
              this.priceLog.push(log)
            }
          }
        }
        this.$tkParse.post('/totalPrice/toPriceLog', this.priceLog)
      }
    },
    async submit () {
      this.loading = true
      // 清除不完整原材料数据
      let f = this.formula.filter((e) => {
        return e.rawMaterial && e.weight && e.price
      })
      let arr = []
      if (f.length) { arr = f.map((f) => { return f.rawMaterial.objectId }) }
      await this.$modelAjax.put('parts', this.record.objectId, {
        formula: f,
        rawMaterialId: arr,
        price: this.total
      }).catch(e => {
        throw this.$notification['error']({
          message: '保存失败',
          description: '保存失败，请重新尝试'
        })
      })
      this.$notification['success']({
        message: '保存成功',
        description: '数据已保存'
      })
      this.toPriceLog()
      this.$tkParse.post('/implicitMaterial', this.record.objectId) // 更新与此半成品有关的成品的隐式原材料
      this.vm.refresh()
      this.$emit('complete', 'cancel')
    }
  },
  props: {
    vm: null,
    record: Object
  }
}
</script>

<style scoped lang="scss">
  ::v-deep .ant-select{
    width: 100% !important;
  }
  ::v-deep .ant-form-item-label > label::after {
    content: none !important;
  }
  ::v-deep .ant-form-item-label > label {
    font-size: 14px !important;
    color: rgba(102, 102, 102, 1) !important;
  }
</style>
